import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import * as LotActionType from "../constants";
import folder from "assets/img/folder.png";
import word from "assets/img/file_word.png";
import excel from "assets/img/file_excel.png";
import pdf from "assets/img/file_pdf.png";
import ppt from "assets/img/file_pp.png";
import video from "assets/img/file_video.png";
import other from "assets/img/file_other.png";
import { Panel, Table, Tab, Row, Col, Nav, NavItem } from "react-bootstrap";
import Moment from "moment";
import "../lot-list.scss";
import { Modal } from "react-bootstrap";

class HomeownerProperty extends Component {
  static propTypes = {
    match: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    dispatch: PropTypes.func,
    HomeownerLots: PropTypes.array,
    LotDocuments: PropTypes.array, // Added LotDocuments to propTypes
  };

  constructor(props) {
    super(props);
    this.state = {
      showPropertyInfo: true,
      showOwnershipInfo: true,
      selectedLotId: null, // Start with null
      lotDetails: null,
      documents: this.props.LotDocuments ? this.props.LotDocuments : null,
      activeTab: "first",
      searchQuery: "",
      sortAscending: false,
      lotSortAscending: false,
      sortedLots: this.props.HomeownerLots ? this.props.HomeownerLots : null,
      previewModalOpen: false,
      previewContent: null,
      previewType: null,
      defaultLot: null,
      // --- NEW: State flag to solve the race condition ---
      defaultLotFetched: false,
    };
  }

  togglePanel = (panelName) => {
    this.setState((prevState) => ({
      [panelName]: !prevState[panelName],
    }));
  };

  // MODIFIED: componentDidMount now only starts the data fetching process.
  componentDidMount() {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_LIST_ASYNC,
    });

    this.props.dispatch({
      type: LotActionType.RESET_LOT_PROFILE,
    });

    this.props.dispatch({
      type: LotActionType.GET_DEFAULT_LOT,
      callback: (response) => {
        if (response && response.data && response.data.lotId) {
          this.setState({
            defaultLot: response.data.lotId,
            defaultLotFetched: true,
          });
        } else {
          this.setState({
            defaultLotFetched: true,
          });
        }
      },
    });
  }

  // MODIFIED: componentDidUpdate now handles all the logic safely.
  componentDidUpdate(prevProps) {
    const { HomeownerLots } = this.props;
    const { defaultLotFetched, selectedLotId } = this.state;

    // --- FIX: The main logic block. It runs only ONCE. ---
    // It waits until the lots have arrived, the default lot is fetched, and no lot has been selected yet.
    if (
      HomeownerLots && // Check if HomeownerLots exists
      HomeownerLots.length > 0 &&
      defaultLotFetched &&
      !selectedLotId &&
      (prevProps.HomeownerLots !== HomeownerLots || // Data changed
        (!prevProps.defaultLotFetched && defaultLotFetched)) // Default lot just fetched
    ) {
      this.selectInitialLot();
    }

    // This part is for handling subsequent document updates.
    if (
      prevProps.LotDocuments !== this.props.LotDocuments &&
      Array.isArray(this.props.LotDocuments)
    ) {
      this.setState({ documents: this.props.LotDocuments });
    }
  }

  // --- NEW: A dedicated function to select the correct initial lot. ---
  selectInitialLot = () => {
    const { HomeownerLots } = this.props;
    const { defaultLot } = this.state;
    let lotToSelect = null;

    // First, try to find the default lot in the list.
    if (defaultLot) {
      lotToSelect = HomeownerLots.find((l) => l.lot.id === defaultLot);
    }

    // If the default lot wasn't found, or if there was no default lot, fall back to the first lot in the list.
    if (!lotToSelect && HomeownerLots.length > 0) {
      const sortedLots = [...HomeownerLots].sort((a, b) =>
        a.lot.streetAddress.localeCompare(b.lot.streetAddress)
      );
      lotToSelect = sortedLots[0];
    }

    // If we have a lot to select, set the state and fetch its details.
    if (lotToSelect) {
      const lotId = lotToSelect.lot.id;
      this.setState({
        selectedLotId: lotId,
        // Also update sortedLots to reflect the initial state correctly
        sortedLots: [...this.props.HomeownerLots].sort((a, b) =>
          a.lot.streetAddress.localeCompare(b.lot.streetAddress)
        ),
      });

      if (lotToSelect.builderProfile) {
        this.onBindHomeownerLotDetail(lotToSelect.builderProfile);
        this.onBindHomeownerLotDocument(lotToSelect.builderProfile, lotId);
      }
    }
  };

  // This function is for when a user manually clicks a lot in the list.
  onGetBuilderProfile = (lotId) => {
    if (this.state.selectedLotId === lotId) return; // Prevent refetching

    this.setState({
      selectedLotId: lotId,
      lotDetails: null, // Clear old details to show a loading state
      documents: null,
    });

    const lot = this.props.HomeownerLots.find((l) => l.lot.id === lotId);
    if (lot && lot.builderProfile) {
      this.onBindHomeownerLotDetail(lot.builderProfile);
      this.onBindHomeownerLotDocument(lot.builderProfile, lotId);
    }
  };

  onBindHomeownerLotDetail = (builderProfile) => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_DETAIL_ASYNC,
      params: {
        endpoint: builderProfile.lotDetailEndpoint,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken,
        },
      },
      callback: (data) => {
        // Callback in original code called renderPropertyDetails, which is not ideal.
        // Simply setting state is better practice.
        this.setState({ lotDetails: data });
      },
    });
  };

  onBindHomeownerLotDocument = (builderProfile, lotId) => {
    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_LOT_DOCUMENT_ASYNC,
      params: {
        endpoint: builderProfile.builderHost,
        headers: {
          key: builderProfile.headerKey,
          value: builderProfile.securityToken,
        },
        lotId: lotId,
      },
    });
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  sortDocumentsByName = () => {
    const { sortAscending, documents } = this.state;
    if (!documents) return;

    const sortedDocuments = [...documents].sort((a, b) => {
      const nameA = a.fileName.toLowerCase();
      const nameB = b.fileName.toLowerCase();
      if (nameA < nameB) return sortAscending ? -1 : 1;
      if (nameA > nameB) return sortAscending ? 1 : -1;
      return 0;
    });

    this.setState({
      documents: sortedDocuments,
      sortAscending: !sortAscending,
    });
  };

  sortLotsByStreetAddress = () => {
    const { lotSortAscending, sortedLots } = this.state;
    // Ensure sortedLots is not null before sorting
    const lotsToSort = sortedLots || this.props.HomeownerLots || [];
    const sorted = [...lotsToSort].sort((a, b) => {
      const addressA = a.lot.streetAddress.toLowerCase();
      const addressB = b.lot.streetAddress.toLowerCase();
      if (addressA < addressB) return lotSortAscending ? 1 : -1;
      if (addressA > addressB) return lotSortAscending ? -1 : 1;
      return 0;
    });

    this.setState({
      sortedLots: sorted,
      lotSortAscending: !lotSortAscending,
    });
  };

  // --- All RENDER methods below are UNCHANGED from your original code ---

  renderLotOwners = () => {
    const { searchQuery, sortedLots } = this.state;

    if (!sortedLots || sortedLots.length === 0) {
      return <div>Loading lots...</div>; // or return null
    }

    const filteredLots = sortedLots.filter((item) =>
      item.lot.streetAddress.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
      <ul className="list-group property-list">
        {filteredLots.map((item) => {
          const isActive = this.state.selectedLotId === item.lot.id;
          const bookMaek = this.state.defaultLot === item.lot.id;
          return (
            <li
              key={item.lot.id}
              className={`list-group-item lot-item ${isActive ? "active" : ""}`}
              onClick={() => this.onGetBuilderProfile(item.lot.id)}
            >
              <div className="lot-item-left">
                <i className="fa fa-map-o lot-icon" aria-hidden="true"></i>
                <span className="lot-title">
                  {item.lot.streetAddress}
                  {bookMaek && <i className="fa fa-star"></i>}
                </span>
                <p className="lot-subtitle">
                  {item.project.city}, {item.project.state}
                </p>
              </div>
              <div className="lot-item-right lot-arrow">
                <i className="fa fa-arrow-up" aria-hidden="true"></i>
              </div>
            </li>
          );
        })}
      </ul>
    );
  };

  renderLotTenancies = (tenancies) => {
    // This function had an error with 'filteredLots', corrected to use the 'tenancies' prop
    const { searchQuery } = this.state;
    const filteredLots = tenancies.filter((item) =>
      item.lot.streetAddress.toLowerCase().includes(searchQuery.toLowerCase())
    );
    return (
      <React.Fragment>
        <div
          style={{
            marginBottom: 10,
            fontSize: 16,
            fontWeight: 500,
            color: "#4d4d4d",
          }}
        >
          Lots that I rent
        </div>
        <ul className="list-group property-list">
          {filteredLots.map((item) => {
            const isActive = this.state.selectedLotId === item.lot.id;
            return (
              <li
                key={item.lot.id}
                className={`list-group-item lot-item ${
                  isActive ? "active" : ""
                }`}
                onClick={() => this.onGetBuilderProfile(item.lot.id)}
              >
                <div className="lot-item-left">
                  <i className="fa fa-map-o lot-icon" aria-hidden="true"></i>
                  <span className="lot-title">{item.lot.streetAddress}</span>
                  <p className="lot-subtitle">
                    {item.project.city}, {item.project.state}
                  </p>
                </div>
                <div className="lot-item-right lot-arrow">
                  <i className="fa fa-arrow-up" aria-hidden="true"></i>
                </div>
              </li>
            );
          })}
        </ul>
      </React.Fragment>
    );
  };

  renderPropertyDetails = () => {
    const { showPropertyInfo, showOwnershipInfo, lotDetails } = this.state;
    return (
      <div>
        {/* Property Info Accordion */}
        <Panel>
          <Panel.Heading onClick={() => this.togglePanel("showPropertyInfo")}>
            <div className="accordion-header">
              <span>
                <i className="fa fa-map-o" aria-hidden="true"></i>
                <span className="lot-titles">Property Info</span>
              </span>
              <span
                className={`glyphicon arrow-icon ${
                  showPropertyInfo
                    ? "glyphicon-chevron-up"
                    : "glyphicon-chevron-down"
                }`}
              ></span>
            </div>
          </Panel.Heading>
          {showPropertyInfo && (
            <Panel.Body>
              <Table bordered className="accordion-table">
                {lotDetails ? (
                  <tbody>
                    <tr>
                      <th>Property Info</th>
                      <td>{lotDetails ? lotDetails.projectName : ""}</td>
                    </tr>
                    <tr>
                      <th>Location</th>
                      <td
                        style={{
                          whiteSpace: "normal",
                          wordWrap: "break-word",
                          maxWidth: "250px",
                        }}
                      >
                        {lotDetails.location || ""}
                        <br /> <br />
                        <a
                          className="directions-btn"
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                            lotDetails.location || ""
                          )}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i
                            className="fa fa-map-marker"
                            aria-hidden="true"
                          ></i>
                          Directions
                        </a>
                      </td>
                    </tr>

                    <tr>
                      <th>Street Address</th>
                      <td>{lotDetails ? lotDetails.streetAddress : ""}</td>
                    </tr>
                    <tr>
                      <th>Original COE</th>
                      <td>
                        {lotDetails && lotDetails.coe ? (
                          <strong>
                            {Moment(lotDetails.coe).format("MM/DD/YYYY")}
                          </strong>
                        ) : (
                          <span style={{ opacity: ".5" }}>(Not specified)</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <th>Note</th>
                      <td>
                        {lotDetails && lotDetails.note ? (
                          lotDetails.note
                        ) : (
                          <span style={{ opacity: ".5" }}>(Not specified)</span>
                        )}
                      </td>
                    </tr>
                  </tbody>
                ) : (
                  ""
                )}
              </Table>
            </Panel.Body>
          )}
        </Panel>

        {/* Ownership Info Accordion */}
        <Panel>
          <Panel.Heading onClick={() => this.togglePanel("showOwnershipInfo")}>
            <div className="accordion-header">
              <span>
                <i className="fa fa-user-circle-o" aria-hidden="true"></i>

                <span className="lot-titles">Ownership Info</span>
              </span>
              <span
                className={`glyphicon arrow-icon ${
                  showOwnershipInfo
                    ? "glyphicon-chevron-up"
                    : "glyphicon-chevron-down"
                }`}
              ></span>
            </div>
          </Panel.Heading>
          {showOwnershipInfo && (
            <Panel.Body>
              <Table bordered className="accordion-table">
                {lotDetails
                  ? lotDetails.lotOwnerships.map((item, index) => (
                      <tbody key={index}>
                        <tr>
                          <th>Current Owner</th>
                          <td>
                            <a>{item.homeowner.fullName}</a>
                          </td>
                        </tr>
                        <tr>
                          <th>Email</th>

                          <td>{item.homeowner.email}</td>
                        </tr>
                        <tr>
                          <th>Purchase Date</th>
                          <td>
                            {" "}
                            {item.purchaseDate ? (
                              <strong>
                                {Moment(item.purchaseDate).format("MM/DD/YYYY")}
                              </strong>
                            ) : (
                              <span style={{ opacity: ".5" }}>
                                (Not specified)
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    ))
                  : ""}
              </Table>
            </Panel.Body>
          )}
        </Panel>
      </div>
    );
  };

  renderPropertyDocument = () => {
    const { documents } = this.state;
    const isDisabled = !Array.isArray(documents) || documents.length === 0;
    return (
      <div className="p-6 max-w-md mx-auto">
        {/* Sort Dropdown */}
        <div className="flex items-center justify-end mb-4">
          <button
            className="name-btn"
            type="button"
            data-toggle="dropdown"
            disabled={isDisabled}
            onClick={this.sortDocumentsByName}
            style={isDisabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}
          >
            Name
            {this.state.sortAscending ? (
              <i className="fa fa-angle-up" aria-hidden="true"></i>
            ) : (
              <i className="fa fa-angle-down" aria-hidden="true"></i>
            )}
          </button>
        </div>
        {this.state.documents && this.state.documents.length > 0
          ? this.renderHomeownerFiles(this.state.documents)
          : this.renderNoFiles()}
      </div>
    );
  };

  renderFileTypeIcon = (item) => {
    const extWord = ["doc", "docx"];
    const extExcel = ["xls", "xlsx"];
    const extPpt = ["ppt", "pptx"];
    const extImage = ["jpg", "jpeg", "png", "gif"];
    const extVideo = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];
    const ext = item.fileName.split(".").pop().toLowerCase();
    if (extWord.includes(ext)) {
      return word;
    } else if (extExcel.includes(ext)) {
      return excel;
    } else if (extPpt.includes(ext)) {
      return ppt;
    } else if (extPpt.includes(ext)) {
      return ppt;
    } else if (extVideo.includes(ext)) {
      return video;
    } else if (ext === "pdf") {
      return pdf;
    } else if (extImage.includes(ext)) {
      return item.url;
    } else {
      return other;
    }
  };

  handleShow = (file) => {
    this.setState({ previewFile: file });
  };

  openPreview = (doc) => {
    const url = doc.textAndUrl || doc.url || doc.documentUrl || "";
    const fileName = doc.fileName || doc.name || "Document";
    const fileType = this.getFileType(doc);

    this.setState({
      previewModalOpen: true,
      previewContent: {
        url,
        fileName,
        type: fileType,
      },
    });
  };

  closePreview = () => {
    this.setState({
      previewModalOpen: false,
      previewContent: null,
    });
  };

  renderLinkContent = (docs, label) => {
    const isValidLink = (text) => {
      if (!text) return false;
      try {
        const urlRegex = /^https?:\/\/[^\s]+$/gi;
        const isCleanUrl = urlRegex.test(text);
        if (!isCleanUrl) {
          const containsUrl = /https?:\/\/[^\s]+/gi.test(text);
          return containsUrl;
        }
        return true;
      } catch (e) {
        return false;
      }
    };

    const shouldOpenInNewTab = (doc) => {
      if (!doc) return false;
      const url = doc.textAndUrl || doc.url || doc.documentUrl || "";
      if (!url) return false;
      const extension = url.split(".").pop().toLowerCase();
      const newTabExtensions = [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "svg",
        "webp",
        "pdf",
        "mp4",
        "webm",
        "mov",
        "avi",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "txt",
      ];
      return newTabExtensions.includes(extension);
    };

    return (
      <div className="form-group link-document-fields">
        {label && <label style={{ fontWeight: "bold" }}>{label}</label>}
        <div style={{ marginTop: label ? "20px" : "0" }}>
          {docs.map((doc, index) => {
            const displayText =
              doc.fileName || doc.name || doc.textAndUrl || "";
            const linkContent =
              doc.textAndUrl || doc.url || doc.documentUrl || "";
            const fileTypeIcon = this.renderFileTypeIcon(doc);
            const validLink = isValidLink(linkContent);
            const openInNewTab = shouldOpenInNewTab(doc);
            const updatedBy = doc.updatedBy || "Club Matridis";
            const updatedDate = doc.updatedDate || doc.createdDate;

            return (
              <div key={index} className="document-item-container">
                <div className="document-item-content">
                  <img
                    src={fileTypeIcon}
                    alt="file type"
                    className="doc-icon"
                    style={{
                      width: "45px",
                      height: "45px",
                    }}
                  />
                  {validLink && !openInNewTab ? (
                    <a
                      href={linkContent}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="document-link"
                      style={{ textDecoration: "none", color: "inherit" }}
                      title={linkContent}
                    >
                      <div className="document-info">
                        <div className="document-name">{displayText}</div>
                        <div className="document-meta">
                          {Moment(updatedDate).format("MM/DD/YYYY")}
                        </div>
                      </div>
                    </a>
                  ) : (
                    <div
                      className={`document-link ${
                        validLink ? "clickable" : ""
                      }`}
                      onClick={() => {
                        if (validLink && openInNewTab) {
                          this.openPreview(doc);
                        }
                      }}
                      style={{ cursor: validLink ? "pointer" : "not-allowed" }}
                    >
                      <div className="document-info">
                        <div className="document-name">{displayText}</div>
                        <div className="document-meta">
                          {Moment(updatedDate).format("MM/DD/YYYY")}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  getFileType = (item) => {
    if (!item) return "other";

    const fileName = item.fileName || item.name || "";
    if (!fileName) return "other";

    const ext = fileName.split(".").pop().toLowerCase();

    if (["doc", "docx"].includes(ext)) return "word";
    if (["xls", "xlsx"].includes(ext)) return "excel";
    if (["ppt", "pptx"].includes(ext)) return "ppt";
    if (["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"].includes(ext))
      return "video";
    if (ext === "pdf") return "pdf";
    if (["jpg", "jpeg", "png", "gif"].includes(ext)) return "image";
    return "other";
  };

  renderPreviewModal = () => {
    const { previewModalOpen, previewContent } = this.state;
    if (!previewContent) return null;

    const fileExt = previewContent.url.split(".").pop().toLowerCase();
    const imageFiles = ["jpg", "jpeg", "png", "gif", "webp"];
    const videoFiles = ["mp4", "webm", "ogg", "mov", "avi"];
    const officeFiles = ["doc", "docx", "xls", "xlsx"];

    const renderError = (message = "Failed to load preview.") => (
      <div className="unsupported-preview">
        <p>{message}</p>
        <button
          onClick={() => window.open(previewContent.url, "_blank")}
          className="btn btn-primary"
        >
          Open in New Tab
        </button>
      </div>
    );

    const renderOfficePreview = () => {
      const officeOnlineUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
        previewContent.url
      )}`;
      return (
        <iframe
          src={officeOnlineUrl}
          style={{ width: "100%", height: "70vh", border: "none" }}
          title={`Office Document Viewer - ${previewContent.fileName}`}
        />
      );
    };

    const renderPreview = () => {
      try {
        if (imageFiles.includes(fileExt)) {
          return (
            <img
              src={previewContent.url}
              alt={previewContent.fileName}
              style={{ maxHeight: "80vh", maxWidth: "100%" }}
            />
          );
        }
        if (videoFiles.includes(fileExt)) {
          return (
            <video controls style={{ maxWidth: "100%", maxHeight: "80vh" }}>
              <source src={previewContent.url} type={`video/${fileExt}`} />
              Your browser does not support the video tag.
            </video>
          );
        }
        if (fileExt === "pdf" || fileExt === "txt") {
          return (
            <div style={{ height: "70vh", width: "100%" }}>
              <iframe
                src={previewContent.url}
                title={previewContent.fileName}
                className="pdf-iframe"
                frameBorder="0"
              />
            </div>
          );
        }
        if (officeFiles.includes(fileExt)) {
          return renderOfficePreview();
        }
        return renderError("Preview not available for this file type.");
      } catch (error) {
        return renderError();
      }
    };

    return (
      <Modal
        show={previewModalOpen}
        onHide={this.closePreview}
        centered
        className="custom-preview-modal"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{previewContent.fileName}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center", minHeight: "500px" }}>
          {renderPreview()}
        </Modal.Body>
      </Modal>
    );
  };

  renderHomeownerFiles = (documents) => {
    const files = documents || [];

    return <React.Fragment>{this.renderLinkContent(files, "")}</React.Fragment>;
  };

  renderNoFiles = () => {
    return (
      <div className="lot-document-no-files-block">
        <img className="lot-document-no-files-ic" src={folder} alt="no-files" />
        <p className="lot-document-no-files-text">No files</p>
      </div>
    );
  };

  postDefaultlotsAdd = () => {
    this.props.dispatch({
      type: LotActionType.POST_DEFAULT_LOT,
      params: {
        data: { lotId: this.state.selectedLotId },
      },
      callback: () => {
        window.location.reload();
      },
    });
  };

  render() {
    const lotOwners = this.props.HomeownerLots.filter(
      (x) => x.owner && x.owner.status === 1
    );
    const tenancies = this.props.HomeownerLots.filter(
      (x) => x.tenancy && x.tenancy.status === 1
    );
    const { activeTab } = this.state;
    return (
      <div className="container-fluid app-container">
        <div className="row lot-row">
          <div className="col-sm-3">
            <div className="property-sidebar">
              <div className="dropdown filter-dropdown">
                <button
                  className="name-btn"
                  type="button"
                  data-toggle="dropdown"
                  onClick={this.sortLotsByStreetAddress}
                >
                  Name{" "}
                  {this.state.lotSortAscending ? (
                    <i className="fa fa-angle-up" aria-hidden="true"></i>
                  ) : (
                    <i className="fa fa-angle-down" aria-hidden="true"></i>
                  )}
                </button>
              </div>
              {lotOwners.length > 0 && this.renderLotOwners(lotOwners)}
              {tenancies.length > 0 && this.renderLotTenancies(tenancies)}
            </div>
          </div>
          <div className="col-sm-9">
            <Tab.Container id="left-tabs-example" defaultActiveKey="first">
              <Row className="clearfix">
                <Col sm={12} className="property-tabs">
                  <Nav bsStyle="pills" className="property-tabs">
                    <NavItem eventKey="first">
                      <button
                        onClick={() => this.handleTabChange("first")}
                        className={`btn ${
                          activeTab === "first" ? "btn-siteone" : "not-active"
                        }`}
                      >
                        <i className="fa fa-info-circle" aria-hidden="true"></i>{" "}
                        Details
                      </button>
                    </NavItem>
                    <NavItem eventKey="second">
                      <button
                        onClick={() => this.handleTabChange("second")}
                        className={`btn ${
                          activeTab === "second" ? "btn-siteone" : "not-active"
                        }`}
                      >
                        <i className="fa fa-file-text-o" aria-hidden="true"></i>{" "}
                        Documents
                      </button>
                    </NavItem>
                    {this.state.defaultLot != this.state.selectedLotId && (
                      <NavItem eventKey={activeTab}>
                        <button
                          disabled={
                            this.state.defaultLot === this.state.selectedLotId
                          }
                          onClick={() => this.postDefaultlotsAdd()}
                          className={`btn not-active`}
                        >
                          <i className="fa fa-star" aria-hidden="true"></i>
                          Make Default
                        </button>
                      </NavItem>
                    )}
                  </Nav>
                  <div
                    className="search-container"
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <i
                      className="fa fa-search"
                      style={{
                        position: "absolute",
                        top: "38%",
                        left: "12px",
                        transform: "translateY(-50%)",
                        pointerEvents: "none",
                        color: "rgb(159 155 155)",
                        fontSize: "16px",
                      }}
                      aria-hidden="true"
                    ></i>
                    <input
                      type="text"
                      placeholder="Search Property Name"
                      className="search-input"
                      style={{
                        padding: "7px 14px 6px 35px", // left padding to make room for icon
                        borderRadius: "50px",
                        border: "1px solid #ccc",
                        width: "250px",
                      }}
                      value={this.state.searchQuery}
                      onChange={(e) =>
                        this.setState({ searchQuery: e.target.value })
                      }
                    />
                  </div>
                </Col>
                <Col sm={12}>
                  <Tab.Content animation className="property-details">
                    <Tab.Pane eventKey="first">
                      {this.renderPropertyDetails()}
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                      {" "}
                      {this.renderPropertyDocument(this.props.LotDocuments)}
                    </Tab.Pane>
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          </div>
        </div>
        {this.renderPreviewModal()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    HomeownerLots: state.LotStore.HomeownerLots,
    LotDocuments: state.LotStore.LotDocuments,
  };
};

export default connect(mapStateToProps)(HomeownerProperty);



// WEBPACK FOOTER //
// ./src/Lots/Containers/homeowner-property.js